import { Text } from "component/text";
import React from "react";
import { Box } from "zmp-ui";
import "./style.scss";
import { useRecoilValue } from "recoil";
import { orderState } from "state";
import { ORDER_STATUS } from "interfaces/const";
import { formatDatetime } from "component/form/datePicker/_functions";
import { useSearchParams } from "react-router-dom";

export function SuccessOrder() {
  const order = useRecoilValue(orderState);
  const orderDate = order.date
    ? formatDatetime(new Date(order.date), "dd/MM/yyyy hh:mm")
    : "";
  const orderCreateDate = order.dt_created
    ? formatDatetime(new Date(order.dt_created), "dd/MM/yyyy hh:mm")
    : "";
  const shippingStatus = ORDER_STATUS.find((item) => {
    return +item.status === (+order.shipping_status_id || 21);
  });

  const [searchParams] = useSearchParams();
  const isCompeleted = searchParams.get("completed") || "";
  return (
    <Box className="bg-background rounded-xl">
      {!isCompeleted ? (
        <div className="success-order object-fill">
          <div className="success-order__body">
            <Text
              fontSize={20}
              fontWeight={600}
              style={{ marginBottom: "8px" }}
            >
              Đơn hàng #{order.id}
            </Text>
            <Text>Ngày đặt hàng: {orderDate}</Text>
            <Text className="success-order__status" fontWeight={600}>
              {shippingStatus.title}
            </Text>
            <div>
              {order.billcode && (
                <>
                  <Text fontWeight={600}>Mã vận đơn: #{order.billcode}</Text>
                  <Text
                    as="a"
                    href={order?.hyperlink}
                    target="_blank"
                    color={"#1A5CFF"}
                  >
                    &nbsp;(Xem hành trình vận đơn)
                  </Text>
                  <Text as='p' fontSize={12}>Ngày gửi đơn: {orderCreateDate}</Text>
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="success-order object-fill">
          <div className="success-order__body">
            <Text
              fontSize={20}
              fontWeight={600}
              style={{ marginBottom: "8px" }}
            >
              Đặt hàng thành công
            </Text>
            <Text>Ngày đặt hàng: {orderDate}</Text>
            <Text
              fontWeight={600}
              style={{ marginTop: "8px" }}
            >
              Mã đơn hàng: #{order.id}
            </Text>
          </div>
        </div>
      )}
    </Box>
  );
}
